/* ============================================================
   CARAIBI — theme.js v4
   Nav · Cart AJAX · Mobile nav · Reveal · Lazy · Sticky · Variants
   Vanilla JS ES2020+ · Sin dependencias · Performance first
   ============================================================ */

(function () {
  'use strict';

  /* El navegador a veces "recuerda" el scroll de una URL ya visitada y lo
     restaura al volver a ella (incluso al llegar por un enlace nuevo, no
     solo con el botón atrás) — por eso un CTA podía aterrizar al final de
     la página de destino. Esto lo desactiva: cada página siempre empieza
     arriba salvo que el propio código decida scrollear a otro sitio. */
  if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }

  /* ── HELPERS ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function formatMoney(cents) {
    return new Intl.NumberFormat('es-ES', { style:'currency', currency:'EUR', minimumFractionDigits:2 }).format(cents / 100);
  }
  function markImagesLoaded(ctx) {
    qsa('img', ctx).forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('loaded'); }
      else { img.addEventListener('load', function() { img.classList.add('loaded'); }, { once:true }); }
    });
  }

  /* ── 1. NAV TRANSPARENTE SOBRE HERO ── */
  function initNavTransparency() {
    var header = qs('[data-header]');
    var hero   = qs('.section-hero-a, .section-hero-b, .hero-a, [class*="hero"]');
    if (!header || !hero) return;
    var obs = new IntersectionObserver(function(entries) {
      header.classList.toggle('is-transparent', entries[0].isIntersecting);
    }, { rootMargin:'-' + getComputedStyle(document.documentElement).getPropertyValue('--nav-height').trim() + ' 0px 0px 0px', threshold:0.05 });
    obs.observe(hero);
  }

  /* ── 3. MOBILE NAV ── */
  function initMobileNav() {
    var burger  = qs('[data-nav-burger]');
    var drawer  = qs('[data-mobile-nav]');
    var overlay = qs('[data-nav-overlay]');
    var closeBtn= qs('[data-nav-close]');
    if (!burger || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded','true');
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      burger.setAttribute('aria-expanded','false');
    }

    burger.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

    // Trap focus en drawer abierto
    drawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = qsa('a,button,input,[tabindex]:not([tabindex="-1"])', drawer);
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });
  }

  /* ── 4. CART DRAWER ── */
  function initCartDrawer() {
    var drawer   = qs('[data-cart-drawer]');
    var overlay  = qs('[data-cart-overlay]');
    var closeBtns= qsa('[data-cart-close]');
    if (!drawer) return;

    function openDrawer() {
      refreshCart();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // ATC intercept — captura todos los forms /cart/add
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form[action="/cart/add"], form[action="' + window.CARAIBI_ROUTES.cart_add_url + '"]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.disabled = true; submitBtn.textContent = 'Añadiendo...'; }
      fetch('/cart/add.js', { method:'POST', body: new FormData(form) })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText || 'Añadir al carrito →'; }
          openDrawer();
        })
        .catch(function(err) {
          console.error('ATC error:', err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText || 'Añadir al carrito →'; }
        });
    });

    // Cart icon → abrir drawer
    var cartLink = qs('[data-cart-link]');
    if (cartLink) {
      cartLink.addEventListener('click', function(e) { e.preventDefault(); openDrawer(); });
    }

    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeDrawer); });
    overlay && overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

    // Mensaje de regalo — desplegable + guarda en cart.note
    var giftToggle   = qs('[data-gift-toggle]');
    var giftPanel    = qs('[data-gift-panel]');
    var giftIcon     = qs('[data-gift-icon]');
    var giftTextarea = qs('[data-gift-textarea]');
    if (giftToggle && giftPanel) {
      giftToggle.addEventListener('click', function() {
        var isOpen = giftToggle.getAttribute('aria-expanded') === 'true';
        giftToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) { giftPanel.setAttribute('hidden',''); } else { giftPanel.removeAttribute('hidden'); }
        if (giftIcon) giftIcon.textContent = isOpen ? '+' : '–';
      });
    }
    if (giftTextarea) {
      var giftSaveTimer;
      giftTextarea.addEventListener('input', function() {
        clearTimeout(giftSaveTimer);
        giftSaveTimer = setTimeout(function() {
          fetch('/cart/update.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({ note: giftTextarea.value })
          }).catch(function(e) { console.warn('Gift note update:', e); });
        }, 500);
      });
    }

    // Cross-sell — añadir al carrito sin cerrar/reabrir el drawer
    var crossSellBtn = qs('[data-cross-sell-add]');
    if (crossSellBtn) {
      crossSellBtn.addEventListener('click', function() {
        var variantId = crossSellBtn.dataset.variantId;
        if (!variantId) return;
        crossSellBtn.disabled = true;
        crossSellBtn.textContent = 'Añadiendo...';
        fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({ items:[{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function() { refreshCart(); })
        .catch(function(e) { console.warn('Cross-sell add:', e); })
        .finally(function() {
          crossSellBtn.disabled = false;
          crossSellBtn.textContent = 'Añadir';
        });
      });
    }
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
        updateShippingBar(cart.total_price);
        toggleCartExtras(cart.item_count);
      })
      .catch(function(e) { console.warn('Cart refresh:', e); });
  }

  function toggleCartExtras(itemCount) {
    var crossSell = qs('[data-cart-cross-sell]');
    var gift = qs('[data-cart-gift]');
    [crossSell, gift].forEach(function(el) {
      if (!el) return;
      if (itemCount > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
    });
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateShippingBar(totalPrice) {
    var threshold = parseInt(window.CARAIBI_FREE_SHIPPING, 10);
    if (isNaN(threshold)) threshold = 0;
    var bar = qs('[data-free-shipping-bar]');
    var msg = qs('[data-free-shipping-msg]');
    if (!bar) return;
    if (threshold <= 0) {
      bar.style.width = '100%';
      if (msg) { msg.textContent = 'Envío gratuito a España peninsular'; msg.style.color = 'var(--color-verde)'; }
      return;
    }
    var pct = Math.min((totalPrice / threshold) * 100, 100);
    bar.style.width = pct + '%';
    if (msg) {
      if (pct >= 100) {
        msg.textContent = '¡Envío gratuito incluido!';
        msg.style.color = 'var(--color-verde)';
      } else {
        var rem = Math.ceil((threshold - totalPrice) / 100);
        msg.textContent = 'Te faltan ' + rem + ' € para envío gratis';
      }
    }
  }

  function renderCartItems(cart) {
    var itemsEl = qs('[data-cart-items]');
    var subtotalEl = qs('[data-cart-subtotal]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Tu carrito está vacío.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(item) {
        var safeTitle = escHtml(item.product_title);
        // La API /cart.js expone la imagen como string en item.image — no en
        // item.featured_image (esa propiedad no existe ahí y rompía el render).
        var imgUrl = item.image || (item.featured_image && item.featured_image.url) || '';
        var img = imgUrl ? '<img class="cart-drawer__item-img" src="' + escHtml(imgUrl.replace('http:', 'https:')) + '" alt="' + safeTitle + '">' : '<div class="cart-drawer__item-img" style="background:var(--color-crudo)"></div>';
        return '<div class="cart-drawer__item" data-line-key="' + escHtml(item.key) + '">' +
          img +
          '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-name">' + safeTitle + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__item-variant">' + escHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-drawer__item-row">' +
              '<div class="cart-drawer__qty">' +
                '<button class="cart-drawer__qty-btn" data-action="decrease" data-key="' + escHtml(item.key) + '" aria-label="Disminuir">−</button>' +
                '<span class="cart-drawer__qty-val">' + item.quantity + '</span>' +
                '<button class="cart-drawer__qty-btn" data-action="increase" data-key="' + escHtml(item.key) + '" aria-label="Aumentar">+</button>' +
              '</div>' +
              '<span class="cart-drawer__item-price">' + formatMoney(item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="cart-drawer__item-remove" data-key="' + escHtml(item.key) + '" aria-label="Eliminar ' + safeTitle + '">×</button>' +
        '</div>';
      }).join('');

      // Las imágenes se inyectan aquí después de DOMContentLoaded, así que
      // initLazyImages() nunca las ve — sin esto se quedan a opacity:0 para
      // siempre (regla global img:not(.loaded)) y parece que "no hay foto".
      markImagesLoaded(itemsEl);

      // Qty + remove listeners
      qsa('[data-action]', itemsEl).forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = btn.dataset.key;
          var qtyEl = btn.parentElement.querySelector('.cart-drawer__qty-val');
          var qty = parseInt(qtyEl.textContent);
          cartChange(key, btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1));
        });
      });
      qsa('.cart-drawer__item-remove', itemsEl).forEach(function(btn) {
        btn.addEventListener('click', function() { cartChange(btn.dataset.key, 0); });
      });
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body:JSON.stringify({ id:key, quantity:qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      updateShippingBar(cart.total_price);
      toggleCartExtras(cart.item_count);
    })
    .catch(function(e) { console.warn('Cart change:', e); });
  }

  /* ── 5. SCROLL REVEAL ── */
  function initScrollReveal() {
    var els = qsa('.reveal');
    if (!els.length) return;
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); obs.unobserve(entry.target); }
      });
    }, { rootMargin:'0px 0px -40px 0px', threshold:0.08 });
    els.forEach(function(el) { obs.observe(el); });
  }

  /* ── 6. LAZY IMAGES ── */
  function initLazyImages() {
    markImagesLoaded(document);
  }

  /* ── 7. ANNOUNCEMENT BAR HEIGHT ── */
  function setAnnounceHeight() {
    var ann = qs('.ann-bar');
    var h = ann ? ann.offsetHeight : 0;
    document.documentElement.style.setProperty('--announce-h-actual', h + 'px');
  }

  /* ── 8. VARIANT SELECTOR — actualiza precio e imagen en PDP ── */
  function initVariantSelector() {
    qsa('.pdp-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var wrapper = swatch.closest('.pdp-wrap, [id^="pdp-"]');
        if (!wrapper) return;
        var sid = wrapper.id;

        // Update variant ID en el form
        var variantInput = qs('#' + sid + '-variant-id, [name="id"]', wrapper);
        if (swatch.dataset.variantId && variantInput) {
          variantInput.value = swatch.dataset.variantId;
        }

        // Update precio si hay data-price
        if (swatch.dataset.price) {
          var priceEl = qs('#' + sid + '-price, .pdp-price', wrapper);
          if (priceEl) priceEl.textContent = formatMoney(parseInt(swatch.dataset.price));
        }

        // Update imagen principal si hay data-img-url
        if (swatch.dataset.imgUrl) {
          var mainImg = qs('#' + sid + '-current-img, .pdp-gallery__img', wrapper);
          if (mainImg) { mainImg.src = swatch.dataset.imgUrl; }
        }
      });
    });
  }

  /* ── 9. STICKY MOBILE ATC — aparece cuando el ATC sale de pantalla ── */
  function initStickyMobileAtc() {
    qsa('.pdp-sticky-mobile').forEach(function(bar) {
      var sid = bar.id.replace('-sticky-mobile', '');
      var atc = qs('#' + sid + '-atc');
      if (!atc || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function(entries) {
        var visible = entries[0].isIntersecting;
        bar.style.display = visible ? 'none' : 'block';
        bar.setAttribute('aria-hidden', String(visible));
      }, { threshold:0 });
      obs.observe(atc);
    });
  }

  /* ── 10. ACCORDIONS — gestión aria ── */
  function initAccordions() {
    qsa('[data-accordion-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var body = qs('[data-accordion-body]', btn.parentElement) || btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (body) { open ? body.setAttribute('hidden','') : body.removeAttribute('hidden'); }
      });
    });
  }

  /* ── 11. FORMULARIOS — prevent double submit ── */
  function initFormProtection() {
    qsa('form.pdp-form, form.cust-form, form#CustomerLoginForm, form#CreateCustomerForm').forEach(function(form) {
      form.addEventListener('submit', function() {
        var btn = form.querySelector('[type="submit"]');
        if (btn && !btn.dataset.protected) {
          btn.dataset.protected = '1';
          setTimeout(function() {
            btn.disabled = true;
          }, 10);
        }
      });
    });
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function() {
    initNavTransparency();
    initMobileNav();
    initCartDrawer();
    initScrollReveal();
    initLazyImages();
    setAnnounceHeight();
    initVariantSelector();
    initStickyMobileAtc();
    initAccordions();
    initFormProtection();
  });

  // API pública para secciones que necesiten refrescar
  window.CARAIBI = {
    refreshCart: refreshCart,
    refreshReveal: function() {
      qsa('.reveal:not(.visible)').forEach(function(el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 40) el.classList.add('visible');
      });
    },
    openCart: function() {
      var drawer = qs('[data-cart-drawer]');
      if (drawer) { refreshCart(); drawer.classList.add('is-open'); qs('[data-cart-overlay]') && qs('[data-cart-overlay]').classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    },
    formatMoney: formatMoney
  };

  /* ── QUICK ADD — botón "Añadir al carrito" de las tarjetas de producto
     del catálogo/grid. Añade la variante y abre el panel del carrito al
     momento, sin salir de la página. ── */
  window.caraibCard = {
    addToCart: function(variantId, btn) {
      if (!variantId || !btn) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Añadiendo...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.disabled = false;
          btn.textContent = originalText;
          window.CARAIBI.openCart();
        })
        .catch(function(err) {
          console.error('Quick add error:', err);
          btn.disabled = false;
          btn.textContent = originalText;
        });
    }
  };

})();